var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"dense":"","color":_vm.chipTheme.color,"text-color":_vm.chipTheme.text}},[_c('span',{staticStyle:{"text-transform":"uppercase","letter-spacing":"2px"}},[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }